module.exports = __webpack_public_path__ + "static/media/error.595efa69.svg";